import {
	getCategoryCacheUrlPerimeterSSR,
	type CategorizedStorageControlsCache,
} from '@atlassian/browser-storage-controls';

import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';
import { SSRMeasures } from '@confluence/action-measures/entry-points/SSRMeasures.ts';
import { cfetch } from '@confluence/network';
import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs.ts';

export const MONITORING_ATTRIBUTION = 'backbone';

export const preloadWebStorageCategories =
	async (): Promise<CategorizedStorageControlsCache | null> => {
		if (window.__WEB_STORAGE_CONSENT_CATEGORIES__) {
			return window.__WEB_STORAGE_CONSENT_CATEGORIES__;
		}

		const { perimeter } = getSSRRenderInputs();

		// if we are in FedRAMP, don't preload the consent categories
		if (perimeter === 'fedramp-moderate') {
			window.__WEB_STORAGE_CONSENT_CATEGORIES__ = null;
			return null;
		}

		return SSRMeasures.run('ssr-app/prepare/preloadQuery/fetch:WebStorageCategories', async () => {
			try {
				const res = await cfetch(
					getCategoryCacheUrlPerimeterSSR(
						'bifrost' as any,
						perimeter as any,
						'LOCAL_STORAGE' as any,
					),
					{
						method: 'GET',
						credentials: 'omit',
						headers: {
							Accept: 'application/json',
						},
					},
				);
				if (!res.ok) {
					throw new Error(`Cannot load Cookie Consent Categories: ${res.statusText}`);
				}
				const result = await res.json();
				window.__WEB_STORAGE_CONSENT_CATEGORIES__ = result;
				return result;
			} catch (e) {
				getMonitoringClient().submitError(e, {
					attribution: MONITORING_ATTRIBUTION,
				});
				window.__WEB_STORAGE_CONSENT_CATEGORIES__ = null;
				return null;
			}
		});
	};
